import React from 'react';
import { ProfilePlanPromotion } from '../../../flows/profile/components/ProfilePlanPromotion';
import { useStore } from '../../../store';
import { ISummaryData } from '../../../types';

export const PlanUpgradeBlock = () => {
  const summaryData: ISummaryData = useStore(state => state.summary);
  return <ProfilePlanPromotion planType={summaryData.customer.customerProfile} />;
};
